// src/redux/sagas/authSaga.js
import { call, put, takeLatest } from 'redux-saga/effects';
import axios from 'axios';
import { loginSuccess, loginFailure } from '../reducers/authReducer';
import { getBaseUrl } from '../utils/getBaseUrl';


function* verifyTokenSaga(action) {
  try {
    const token = localStorage.getItem("authToken")  // The JWT token passed to the saga

    // Inline API call for token verification
    const response = yield call(axios.get, `${getBaseUrl()}/api/auth/verify`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    const responseObj = {...response.data.payload,orgId: response.data.payload.orgId}
    yield put(loginSuccess(responseObj));

  } catch (error) {
    // console.log(error.response.status)
    yield put(loginFailure(error));
  }
}

function* loginSaga(action) {
  try {
    const { email, password } = action.payload;
    console.log(action)
    const response = yield call(axios.post, `${getBaseUrl()}/api/auth/login`, {
      email,
      password,
    });
    const token = response.data.accessToken;
    localStorage.setItem("authToken", token);
    yield put(loginSuccess({
      ...response.data.info,
      orgId: response.data.orgId
    }));
  } catch (error) {

    yield put(loginFailure(error));
  }
}

// Watcher saga: Watches for actions dispatched to the store and starts worker saga
function* authSaga() {
  yield takeLatest('auth/verifyToken', verifyTokenSaga);
  yield takeLatest('auth/loginRequest', loginSaga);

}

export default authSaga;
